import React, { useState, useContext, useReducer, useEffect } from 'react';

import { ApiContext } from './apiContext';
import { CHANNEL_API } from '../../api/channel/index';
import { AuthContext } from "../auth/authContext";
import history from '../../history';
import { SHOW_LOADER, FETCH_EVENTS, MERGE_EVENTS } from './constant';
import apiReducer from './apiReducer';

const initialState = {
	events: [],
	loading: false
};

export const ApiState = ({ children }) => {
	const [state, dispath] = useReducer(apiReducer, initialState);
	const [jsonData, setJsonData] = useState({});

	const { currentUser } = useContext(AuthContext);
	const [channels, setChannels] = useState([]);
	const [userInfo, setUserInfo] = useState(null);

	const getAllChannels = async () => {

		if (!channels.length) {
			const resChannels = await CHANNEL_API.getAllChannels();

			setChannels(resChannels);

			return resChannels;
		}

		return channels;
	};

	const getUser = async () => {

		if (!userInfo) {
			const user = await CHANNEL_API.getUser(currentUser.id, currentUser.token);

			setUserInfo(user);
			return user;
		}

		return userInfo;

	};

	const showLoader = () => dispath({ type: SHOW_LOADER });

	const fetchEvents = async () => {
		showLoader();

		const userInfo = await getUser();
		const payload = await CHANNEL_API.getAccountEvents(userInfo.data.account_id, currentUser.token);

		setUserInfo(userInfo);
		dispath({ type: FETCH_EVENTS, payload: payload.data.events });
	};

	const addEvent = async (event, showAlert) => {
		const payload = await CHANNEL_API.addEvent(event, currentUser.token);

		if (payload.data.message) showAlert(payload.data.message, 'danger')

		if (payload.data.success) {
			history.push('/my-streams');
		}

	};

	const loadEventsPage = async (pageNumber, pageCheck) => {
		const userInfo = await getUser();
		const events = await CHANNEL_API.loadEventsPage(userInfo.data.account_id, pageNumber, currentUser.token);

		if (events && events.length) {
			if (pageCheck) {
				return true;
			}

			dispath({ type: MERGE_EVENTS, payload: events });

			return events;
		}

		return false;
	};

	const updateEvent = async (event, showAlert) => {
		const payload = await CHANNEL_API.updateEvent(event, currentUser.token);

		if (payload.data.message) showAlert(payload.data.message, 'danger')

		if (payload.data.success) {
			history.push('/my-streams');
		}

	};

	const deleteEvent = async id => {
		const event = {
			event_id: id
		};

		await CHANNEL_API.deleteEvent(event, currentUser.token);

		setTimeout(() => {
			history.push('/my-streams');
		}, 1000);

	};

	return (
		<ApiContext.Provider value={{
			channels,
			getAllChannels,
			getUser,
			fetchEvents,
			addEvent,
			updateEvent,
			deleteEvent,
			loadEventsPage,
			loading: state.loading,
			events: state.events,
			jsonData,
			setJsonData
		}}>
			{children}
		</ApiContext.Provider>
	);

};